"use client";
import { Pencil, Palette, Monitor, Rainbow } from "lucide-react";

const activities = [
  { icon: Pencil, color: "bg-orange-400", label: "Draw" },
  { icon: Palette, color: "bg-green-400", label: "Color" },
  { icon: Monitor, color: "bg-blue-400", label: "Digital" },
  { icon: Rainbow, color: "bg-purple-400", label: "Create" },
];

const Footer = () => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl">
      <h4 className="text-xl font-bold text-purple-700 mb-4 text-center">
        Learn words by drawing them
      </h4>
      <div className="flex justify-center space-x-4">
        {activities.map((activity, index) => (
          <div
            key={index}
            className={`${activity.color} p-4 rounded-2xl shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-xl animate-bounce`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <activity.icon className="w-8 h-8 text-white" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Footer;
